module.exports = __webpack_public_path__ + "img/hr-level2addon_idle_gun_mask.1a3f5e65.png";